import { fetchFile } from '../../../utils/services/Request'

export const pdfBilling = (body: string): Promise<Blob> => fetchFile('/pdf_billing', body)